<!--
 * @Author: Tahiti
 * @Date: 2025-01-XX
 * @Description: VIP 升级按钮组件
 * @FilePath: /weryai-web/components/VipUpgradeButton.vue
-->
<template>
    <button
        v-if="!sidebarCollapsed"
        class="w-[128px] flex-shrink-0 relative overflow-hidden mx-auto px-3 rounded-[8px] flex items-center text-white transition-all duration-300"
        :class="{
            'h-[40px] bg-black hover:scale-105 justify-center':
                isLoggedIn && subscriptionType,
            'h-[58px] vip-upgrade-btn justify-between':
                !isLoggedIn || !subscriptionType,
        }"
        @click="handleClick"
    >
        <!-- 已订阅状态 -->
        <template v-if="isLoggedIn && subscriptionType">
            <img
                class="absolute z-1 top-[-44px] left-0 min-w-[156px] w-full"
                src="https://static.weryai.com/growth/image/f2308e4bff9f6a89e09839f27ecf26fa.webp"
                alt="vip background"
            />
            <div class="relative z-[2] flex items-center justify-center">
                <img
                    class="relative z-[2] w-10 h-10"
                    :src="currentVipLevelIcon"
                    alt="vip level"
                />
                <div class="text-xs font-medium vip-gradient-text">
                    <span class="text-xs text-center flex flex-col">
                        <span class="truncate">{{ t('menus.expires') }}</span>
                        <span class="truncate">{{
                            accountSummary?.sub_info?.next_billing_date
                        }}</span>
                    </span>
                </div>
            </div>
        </template>

        <!-- 未订阅状态 -->
        <template v-else>
            <!-- 左侧文字 -->
            <div
                class="flex flex-col items-start flex-1 min-w-0 overflow-hidden"
            >
                <span
                    class="text-[11px] font-medium vip-gradient-text truncate max-w-full"
                >
                    {{ t('menus.startVip') }}
                </span>
                <span
                    class="text-[11px] font-medium vip-gradient-text flex items-center gap-0.5 max-w-full"
                >
                    <span class="truncate">{{ t('menus.vipBenefits') }}</span>
                    <span class="text-[10px] flex-shrink-0">›</span>
                </span>
            </div>
            <!-- 右侧图标 -->
            <img
                src="~/assets/images/common/vip-coin-btn.png"
                alt="vip"
                class="w-[32px] h-[40px] flex-shrink-0 ml-1 mt-[8px]"
            />
        </template>
    </button>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useAppStore } from '@/stores/app'
import { useUserStore } from '@/stores/user'
import { emitOpenGoodsModal } from '@/utils/emitter'
import { useI18n } from '~/composables/useI18n'

// Composables
const { t } = useI18n()
const appStore = useAppStore()
const userStore = useUserStore()

// Computed
const isLoggedIn = computed(() => userStore.isLoggedIn)
const accountSummary = computed(() => userStore.accountSummary)
const sidebarCollapsed = computed(() => appStore.sidebarCollapsed)
const subscriptionType = computed(
    () => accountSummary.value?.sub_info?.subscription_type
)

const vipLevelIconEnums = {
    PLAN_ENTRY:
        'https://static.weryai.com/growth/image/31a7c0b3085b4cb7ad40d93a7810bbb7.webp',
    PLAN_BASIC:
        'https://static.weryai.com/growth/image/ea1f1f28a0f59709ad1facf92b3f8f7b.webp',
    PLAN_PRO:
        'https://static.weryai.com/growth/image/53b4bf7c442ed7d724003368ba6755ec.webp',
}

const currentVipLevelIcon = computed(() => {
    if (!accountSummary.value?.sub_info) {
        return 'https://static.weryai.com/growth/image/c685945d08835ac092db36ae22337549.webp'
    }
    return vipLevelIconEnums[
        accountSummary.value?.sub_info
            ?.subscription_type as keyof typeof vipLevelIconEnums
    ]
})

const route = useRoute()
// Methods
const handleClick = () => {
    const path = route.path
    const type = path.includes('/characters') ? 'chat_plan' : ''
    emitOpenGoodsModal(type)
}
</script>

<style scoped lang="less">
.vip-upgrade-btn {
    background: linear-gradient(90deg, #393a20 0%, #23201b 50%, #1f1c17 100%);
    position: relative;

    &::before {
        content: '';
        position: absolute;
        inset: 0;
        padding: 1px;
        border-radius: 8px;
        background: linear-gradient(
            90deg,
            rgba(255, 254, 169, 0.2) 0%,
            rgba(163, 163, 163, 0) 100%
        );
        -webkit-mask:
            linear-gradient(#fff 0 0) content-box,
            linear-gradient(#fff 0 0);
        mask:
            linear-gradient(#fff 0 0) content-box,
            linear-gradient(#fff 0 0);
        -webkit-mask-composite: xor;
        mask-composite: exclude;
        pointer-events: none;
    }

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 12px 40px rgba(169, 255, 201, 0.3);
    }
}

.vip-gradient-text {
    background: linear-gradient(90deg, #fdffb5 0%, #f7cc68 100%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
}
</style>
